/**
 * Personal information validations
 *
 * Validation schemas for personal details: name, last names, birth date, CURP, etc.
 */
import { z } from "zod";
import { t, createValidator } from "./utils";
/**
 * Name validation schema factory
 */
export const nameSchema = () => {
    return z
        .string()
        .min(1, { message: t("required") })
        .max(50, { message: t("name.tooLong") });
};
/**
 * Last name validation schema factory
 */
export const lastNameSchema = () => {
    return z
        .string()
        .min(1, { message: t("required") })
        .max(50, { message: t("lastName.tooLong") });
};
/**
 * Birth date validation schema factory (day part)
 */
export const birthDaySchema = () => {
    return z.string().min(1, { message: t("required") });
};
/**
 * Birth date validation schema factory (month part)
 */
export const birthMonthSchema = () => {
    return z.string().min(1, { message: t("required") });
};
/**
 * Birth date validation schema factory (year part)
 */
export const birthYearSchema = () => {
    return z.string().min(1, { message: t("required") });
};
/**
 * Gender validation schema factory
 */
export const genderSchema = () => {
    return z
        .string()
        .min(1, { message: t("required") })
        .refine((val) => val === "M" || val === "F", {
        message: t("required"),
    });
};
/**
 * CURP validation schema factory
 */
export const curpSchema = () => {
    return z
        .string()
        .min(1, { message: t("required") })
        .regex(/^[A-Z]{4}\d{6}[HM][A-Z]{5}[0-9A-Z]\d$/, {
        message: t("curp.invalid"),
    });
};
/**
 * State of birth validation schema factory
 */
export const stateOfBirthSchema = () => {
    return z.string().min(1, { message: t("required") });
};
// Validator functions
export const validateName = createValidator(nameSchema);
export const validateLastName = createValidator(lastNameSchema);
export const validateBirthDay = createValidator(birthDaySchema);
export const validateBirthMonth = createValidator(birthMonthSchema);
export const validateBirthYear = createValidator(birthYearSchema);
export const validateGender = createValidator(genderSchema);
export const validateCurp = createValidator(curpSchema);
export const validateStateOfBirth = createValidator(stateOfBirthSchema);
